import React, { useState } from "react";
import CatCard from "./CatCard";
import Loader from "./Loader";
import Pagination from "./Pagination";
import { NUMBER_ITEM_PAGINATION, OFFSET_PAGINATION } from "../utils";
import useCats from "../hooks/useCats";
import { GridList } from "@material-ui/core";

const CatList = () => {

 // state pages
  const [pageOfItems, setPageOfitems] = useState([]);
  const [pageActive, setPageActive] = useState([]);
 

  const handlePageChange = (itemsPage, activePage) => {
    setPageOfitems(itemsPage);
    setPageActive(activePage);
  };


  // importing from hook
  const { cats, error, loading } = useCats();

  return (
    <div className="cats-container">
      <div className="container">
        <div className="header">
          <h1 className="heading">Choose Cats</h1>
        </div>
        {loading && (
          <div className="imgContainer">
            <Loader />
          </div>
        )}

        {/* {cats && (
          <ul className="list">
            {cats.map((cat) => (
              <CatCard key={cat.id} cat={cat} />
            ))}
          </ul>
        )} */}
        {/* <ul className="list">
          {cats.map((item, index) => (
            <CatCard
              className={
                index >= pageActive * NUMBER_ITEM_PAGINATION
                  ? "items__item"
                  : "items__item items__item--active"
              }
              key={item.id}
              cat={item}
            />
          ))}
        </ul> */}
        <ul className="list">
          {pageOfItems.map((item) => (
            <CatCard key={item.id} cat={item} />
          ))}
        </ul>
        {error && <div style={{ color: `red` }}>Something went wrong</div>}
        <Pagination
          initialPage={1}
          labelPrevious={"Previous"}
          labelNext={"Next"}
          items={cats}
          pageNeighbours={OFFSET_PAGINATION}
          pageSize={NUMBER_ITEM_PAGINATION}
          onChangePage={handlePageChange}
        />
      </div>
    </div>
  );
};

export default CatList;
